/*
  Fit Creamery — Klaviyo popup close button, step-aware
  -----------------------------------------------------
  On the text-signup step, the popup's X advances to the success step instead
  of closing. On every other step it closes as normal.

  Klaviyo has no public API for "go to step N", so this does not try to drive
  the form itself. It clicks a hidden Klaviyo button that already carries a
  step action, which means the navigation is Klaviyo's own — nothing here
  depends on their internals beyond two class names.

  Set-up in the form editor, both on the TEXT SIGNUP step:

    1. The custom HTML block already carries .fc-tx — that is what marks the
       step, no change needed.
    2. A Button block with the action that lands on the success step
       (SKIP_TO_SUCCESS in this form) and the custom class  fc-advance .
       The CSS hides it.

  If either is missing the X just closes, which is the safe failure.

  Loaded from BOTH layouts: theme.liquid for the storefront, and
  password.liquid because the popup runs on the password page too and that
  layout shares none of theme.liquid's scripts.
*/
(function () {
  'use strict';

  var STEP_MARKER = '.fc-tx';      // present only on the text-signup step
  var ADVANCE_BUTTON = '.fc-advance';

  // Klaviyo's close button may act on pointerdown or mousedown rather than
  // waiting for click, and a click listener alone would then fire after the
  // popup had already gone. Every one of these is swallowed while we are on
  // the text step; the advance itself runs once, on whichever comes first.
  var EVENTS = ['pointerdown', 'mousedown', 'touchstart', 'click'];

  // How long the close button stays inert after an advance. It only has to
  // outlast one press and Klaviyo's rerender, not the whole animation.
  var ADVANCE_SETTLE_MS = 900;

  var lastAdvance = 0;

  function handle(event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    // The X is an SVG inside the button, so the event lands on a <path>.
    var closeButton = target.closest('.klaviyo-close-form');
    if (!closeButton) return;

    // One press fires pointerdown, mousedown and click. The advance runs on
    // the first of them, and Klaviyo rerenders to the success step before the
    // rest arrive -- mounting a NEW close button under the cursor. The click
    // then lands on that new button, on a step where .fc-tx is gone, and the
    // step check below would wave it through: the success step appears and is
    // closed by the same press that asked for it.
    //
    // So the settling window is checked FIRST, before anything about which
    // step we are on. For that moment the close button is inert no matter
    // what is on screen.
    if (Date.now() - lastAdvance < ADVANCE_SETTLE_MS) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    // Scope the lookups to this popup: a page can host more than one form,
    // and closing form A must not read form B's step.
    var popup =
      closeButton.closest('[data-testid="modal-form-container"]') ||
      closeButton.closest('.klaviyo-form') ||
      document;

    if (!popup.querySelector(STEP_MARKER)) return;   // any other step: close

    var advance = popup.querySelector(ADVANCE_BUTTON);
    if (!advance) return;                            // no button: still closes

    // Capture phase plus stopImmediatePropagation is what keeps this from
    // reaching Klaviyo's own handler. React binds at its root container,
    // which is below document, so a document-level capture listener runs
    // first and can cut the event off before it gets there.
    event.preventDefault();
    event.stopImmediatePropagation();

    lastAdvance = Date.now();
    advance.click();
  }

  EVENTS.forEach(function (type) {
    document.addEventListener(type, handle, true);
  });
})();
